<template>
  <div class="wrapper">
    <div class="wrapper-content">
      <div class="title">{{ settingConfig.biName }}</div>
      <div class="flex align-center content justify-around">
        <div class="content-left">
          <div class="content-title">基础概况</div>
          <div class="content-one">
            <div class="content-one-data" @click="gourl('DataCenter')">
              <div class="image-678">
                <lottie :options="lottieOne"/>
              </div>
              <div class="content-text-1">{{ settingConfig.baseOldPersonCount }}</div>
              <div class="content-text-2">老人数据</div>
            </div>
            <div class="content-one-data" @click="gourl('WorkPerson')">
              <div class="image-678">
                <lottie :options="lottieTwo"/>
              </div>
              <div class="content-text-1">{{ settingConfig.baseEmployees }}</div>
              <div class="content-text-2">从业人员</div>
            </div>
            <div class="content-one-data" @click="gourl('ServeOrgs')">
              <div class="image-678">
                <lottie :options="lottieThree"/>
              </div>
              <div class="content-text-1">{{ settingConfig.baseServiceMerchants }}</div>
              <div class="content-text-2">服务商家</div>
            </div>
            <div class="content-one-data" @click="gourl('DeviceDevice')">
              <div class="image-678">
                <lottie :options="lottieFour"/>
              </div>
              <div class="content-text-1">{{ settingConfig.baseNursingHome }}</div>
              <div class="content-text-2">养老院</div>
            </div>
            <div class="content-one-data" @click="gourl('SumCenter')">
              <div class="image-678">
                <lottie :options="lottieFive"/>
              </div>
              <div class="content-text-1">{{ settingConfig.baseCommunityServiceStation }}</div>
              <div class="content-text-2">社区服务站</div>
            </div>
            <div class="content-one-data" @click="gourl('AgedEatMechaismManage')">
              <div class="image-678">
                <lottie :options="lottieSix"/>
              </div>
              <div class="content-text-1">{{ settingConfig.baseCommunityRestaurant }}</div>
              <div class="content-text-2">社区餐厅</div>
            </div>
          </div>
          <div class="content-title">其他数据</div>
          <div class="content-one">
            <div class="content-two-data" @click="gourl('ServeRecords')">
              <div class="image-58">
                <lottie :options="lottie7"/>
              </div>
              <div class="content-text-1">{{ settingConfig.otherServiceData }}</div>
              <div class="content-text-2">服务数据</div>
            </div>
            <div class="content-two-data" @click="gourl('caringPlatform')">
              <div class="image-58">
                <lottie :options="lottie8"/>
              </div>
              <div class="content-text-1">{{ settingConfig.otherIntelligentCare }}</div>
              <div class="content-text-2">智能看护</div>
            </div>
            <div class="content-two-data" @click="gourl('TaskActivity')">
              <div class="image-58">
                <lottie :options="lottie9"/>
              </div>
              <div class="content-text-1">{{ settingConfig.otherCommunityActivities ?? 0 }}</div>
              <div class="content-text-2">社区活动</div>
            </div>
          </div>

          <div class="content-title">老年人年龄及类别</div>
          <div class="chart-one-content">
            <div id="chartOne" class="chart-one"/>
            <div id="chartTwo" class="chart-two"/>
          </div>
        </div>

        <div class="content-center">
          <div class="content-seven">
            <div class="content-seven-title" style="  top: 3.73rem;color: #FFFFFF;">
              人口数量：{{ settingConfig.populationSize }}
            </div>
            <div class="content-seven-title" style="  top:8rem;color: #73FDFF;">
              老人数据：{{ settingConfig.elderlyData }}
            </div>
<!--            <div class="content-seven-content" @click="gourl('monitor')">-->
<!--              <div style="font-size:1.09rem;margin:2rem 0 0 1.73rem;color: #00FFFC;">远程监控</div>-->
<!--              <div class="content-seven-content-border">-->
<!--                <img src="../../../assets/images/bigData/play.png">-->
<!--              </div>-->
<!--            </div>-->
            <div ref="scrollContainer" class="content-eight-content">
              <div ref="scrollContent" class="scroll-content">
                <!--              <vue-seamless-scroll :data="data.srOrders" class="line-scroll-table" :class-option="classOption">-->
                <div
                  v-for="(item,index) in data.srOrders"
                  ref="scrollContentOrder"
                  :key="index"
                  class="s-order"
                  :style="'width:calc(14.81rem + '+(40 * (( 3*height - (index * height +position))/(3*height)))+'px);}'"
                >
                  上门服务：{{ item.oldPersonName }} {{ item.oldPersonPhone }}
                </div>
                <!--              </vue-seamless-scroll>-->
              </div>
            </div>
            <div id="chartFour" class="chart-four"/>
          </div>
          <div class="content-six">
            <div class="content-title">服务工单</div>
            <table>
              <thead>
              <tr>
                <td>姓名</td>
                <td>年龄</td>
                <td>电话号码</td>
                <td>地址</td>
                <td>时间</td>
              </tr>
              </thead>
              <tbody>
              <vue-seamless-scroll :data=" data.serviceOrders" class="line-table" :class-option="classOption">
                <tr v-for="(item,index) in data.serviceOrders" :key="index">
                  <td>{{ item.oldPersonName }}</td>
                  <td>{{ item.oldPersonAge }}</td>
                  <td>{{ item.oldPersonPhone }}</td>
                  <td class="text-cut-one">{{ item.oldPersonAddress }}</td>
                  <td>{{ item.serviceTime }}</td>
                </tr>
              </vue-seamless-scroll>
              </tbody>
            </table>
          </div>
        </div>

        <div class="content-right" style="position: relative">
          <div class="content-title">社区服务</div>
          <div class="content-line">
            <div class="line"/>
            <div class="line-tile">商家类别</div>
          </div>
          <div id="chartThree" class="content-three"/>
          <div class="three-image">
            <lottie :options="lottie10"/>
          </div>
          <div class="content-line">
            <div class="line"/>
            <div class="line-tile">政府兜底服务</div>
          </div>
          <div class="content-four">
            <div class="content-four-data">
              <div class="content-four-progress-all">
                <div
                  class="content-four-percentage"
                  :style="{width: (getPercentage(settingConfig.assessmentOfElderlyAbilities))+'%'}"
                />
                <div
                  class="content-four-percentage-right"
                  :style="{width: 'calc(100% - '+(getPercentage(settingConfig.assessmentOfElderlyAbilities))+'% + 2%)'}"
                />
                <div class="content-four-number">{{ settingConfig.assessmentOfElderlyAbilities }}</div>
              </div>
              <div class="content-four-title">老人能力评估</div>
            </div>
            <div class="content-four-data">
              <div class="content-four-progress-all">
                <div
                  class="content-four-percentage"
                  :style="{width: (getPercentage(settingConfig.elderlyOrientedReform))+'%'}"
                />
                <div
                  class="content-four-percentage-right"
                  :style="{width: 'calc(100% - '+(getPercentage(settingConfig.elderlyOrientedReform))+'% + 2%)'}"
                />
                <div class="content-four-number">{{ settingConfig.elderlyOrientedReform }}</div>
              </div>
              <div class="content-four-title">适老化改造</div>
            </div>
            <div class="content-four-data">
              <div class="content-four-progress-all">
                <div
                  class="content-four-percentage"
                  :style="{width: (getPercentage(settingConfig.governmentAidServices))+'%'}"
                />
                <div
                  class="content-four-percentage-right"
                  :style="{width: 'calc(100% - '+(getPercentage(settingConfig.governmentAidServices))+'% + 2%)'}"
                />
                <div class="content-four-number">{{ settingConfig.governmentAidServices }}</div>
              </div>
              <div class="content-four-title">政府援助服务</div>
            </div>
            <div class="content-four-data">
              <div class="content-four-progress-all">
                <div
                  class="content-four-percentage"
                  :style="{width: (getPercentage(settingConfig.inspectionVisitationServices))+'%'}"
                />
                <div
                  class="content-four-percentage-right"
                  :style="{width: 'calc(100% - '+(getPercentage(settingConfig.inspectionVisitationServices))+'% + 2%)'}"
                />
                <div class="content-four-number">{{ settingConfig.inspectionVisitationServices }}</div>
              </div>
              <div class="content-four-title">空巢独居巡视探访服务</div>
            </div>

          </div>

          <div class="content-title">
            <div :style="serviceType !== 1?'color: rgba(119, 204, 255, 0.7);':''" @click="serviceType = 1">服务项目
            </div>
            <div style="margin:0 0.36rem;color: rgba(119, 204, 255, 0.7);">/</div>
            <div :style="serviceType === 1?'color: rgba(119, 204, 255, 0.7);':''" @click="serviceType = 2">养老院</div>
          </div>
          <div class="content-line">
            <div class="line"/>
            <div class="line-tile">{{ serviceType === 1 ? "服务项目" : "养老院数据" }}</div>
          </div>
          <div v-if="serviceType === 1" class="content-five">
            <div class="content-five-data content-five-data-1">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.mealAssistanceService ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">助餐服务</div>
            </div>
            <div class="content-five-data content-five-data-2" style="margin-left: 0.45rem">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.cleaningAssistanceService ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">助洁服务</div>
            </div>
            <div class="content-five-data content-five-data-3" style="margin-left: 0.45rem">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.medicalAssistanceServices ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">助医服务</div>
            </div>
          </div>

          <div v-if="serviceType === 1" class="content-five">
            <div class="content-five-data content-five-data-4">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.assistiveServices ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">助行服务</div>
            </div>
            <div class="content-five-data content-five-data-5" style="margin-left:2.27rem">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.urgentAssistanceService ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">助急服务</div>
            </div>
          </div>
          <div v-if="serviceType === 2" class="content-five">
            <div class="content-five-data content-five-data-1">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.totalNumberInstitutions ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">机构总数</div>
            </div>
            <div class="content-five-data content-five-data-2" style="margin-left: 0.45rem">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.numberBeds ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">床位数</div>
            </div>
            <div class="content-five-data content-five-data-3" style="margin-left: 0.45rem">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.numberNursingBeds ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">护理型床位数</div>
            </div>
          </div>

          <div v-if="serviceType === 2" class="content-five">
            <div class="content-five-data content-five-data-4">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.numberVacantBeds ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">空闲床位数</div>
            </div>
            <div class="content-five-data content-five-data-5" style="margin-left:2.27rem">
              <div class="flex align-baseline">
                <div class="content-five-text-1">{{ settingConfig.numberElderlyResidents ?? 0 }}</div>
                <div class="content-five-text-2">个</div>
              </div>
              <div class="content-five-title">入住老年人数</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="setting">
      <img src="@/assets/images/bigData/setting.png" class="setting-image" @click="showLayer=true">
    </div>

    <div v-if="showLayer" class="layer-back">
      <div class="layer-content flex flex-column">
        <div class="layer-content-title width-100p text-center">页面内容修改</div>
        <div class="layer-close" @click="showLayer = false">X</div>
        <div class="layer-content-content">
          <div class="flex align-center margin-top-25">
            <div class="layer-input" style="background: #8CEDFF !important;">选择平台</div>
            <select v-model="mapRegionId" class="layer-select-content" @change="changeMapRegion">
              <option v-for="(item,index) in mapRegion" v-if="item.regionId != '566814'" :key="index" :value="item.regionId">{{
                  item.regionName
                }}智慧养老服务平台
              </option>
              <option value="566814">莲湖区智慧家政平台数据中心</option>
            </select>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="layer-input">平台名称</div>
            <input v-model="settingConfigSet.biName" class="layer-input-content">
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">人口数量</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.populationSize" class="">
                <div>人</div>
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">老人数据</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.elderlyData" class="">
                <div>人</div>
              </div>
            </div>
          </div>
          <div class="margin-top-25 color-00d">基础数据：</div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">老人数据</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.baseOldPersonCount" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">从业人员</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.baseEmployees" class="">
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">服务商家</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.baseServiceMerchants" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">养老院</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.baseNursingHome" class="">
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">社区服务站</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.baseCommunityServiceStation" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">社区餐厅</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.baseCommunityRestaurant" class="">
              </div>
            </div>
          </div>

          <div class="margin-top-25 color-00d">其他数据：</div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">服务数据</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.otherServiceData" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">智能看护</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.otherIntelligentCare" class="">
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">社区活动</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.otherCommunityActivities" class="">
              </div>
            </div>
          </div>

          <div class="margin-top-25 color-00d">商家类别：</div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">家政服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.domesticService" class="">
                <div>%</div>
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">医疗护理</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.medicalCare" class="">
                <div>%</div>
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">养老院</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.nursingHome" class="">
                <div>%</div>
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">社区服务站</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.communityServiceStation" class="">
                <div>%</div>
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">旅游旅居</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.travelAccommodation" class="">
                <div>%</div>
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">其他商家</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.otherMerchants" class="">
                <div>%</div>
              </div>
            </div>
          </div>

          <div class="margin-top-25 color-00d">政府兜底服务：</div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">老人能力评估</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.assessmentOfElderlyAbilities" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">适老化改造</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.elderlyOrientedReform" class="">
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">政府援助服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.governmentAidServices" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">空巢独居巡视探访服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.inspectionVisitationServices" class="">
              </div>
            </div>
          </div>
          <div class="margin-top-25 color-00d">服务项目：</div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">助餐服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.mealAssistanceService" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">助洁服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.cleaningAssistanceService" class="">
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">助医服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.medicalAssistanceServices" class="">
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">助行服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.assistiveServices" class="">
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">助急服务</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.urgentAssistanceService" class="">
              </div>
            </div>
          </div>

          <div class="margin-top-25 color-00d">养老院：</div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">机构总数</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.totalNumberInstitutions" class="">
                <div>人</div>
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">床位数</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.numberBeds" class="">
                <div>人</div>
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">护理型床位数</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.numberNursingBeds" class="">
                <div>人</div>
              </div>
            </div>
            <div class="flex align-center margin-left-218">
              <div class="layer-input">空闲床位数</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.numberVacantBeds" class="">
                <div>人</div>
              </div>
            </div>
          </div>
          <div class="flex align-center margin-top-18">
            <div class="flex align-center">
              <div class="layer-input">入住老年人数</div>
              <div class="flex align-center layer-input-content1">
                <input v-model="settingConfigSet.numberElderlyResidents" class="">
                <div>人</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex align-center justify-center width-100p" style="margin-top: 3.64rem">
          <div class="layer-button-1" @click="showLayer = false">取消</div>
          <div class="layer-button-2" @click="submit">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echats from 'echarts'
import lianhu from '@/assets/lianhu.json'
import { mapState, mapMutations, mapActions } from 'vuex'
import Lottie from 'vue-lottie'
import lottieOneJson from '@/assets/images/lottie/1.json'
import lottieTwoJson from '@/assets/images/lottie/2.json'
import lottieThreeJson from '@/assets/images/lottie/3.json'
import lottieFourJson from '@/assets/images/lottie/4.json'
import lottieFiveJson from '@/assets/images/lottie/5.json'
import lottieSixJson from '@/assets/images/lottie/6.json'
import lottie7Json from '@/assets/images/lottie/7.json'
import lottie8Json from '@/assets/images/lottie/8.json'
import lottie9Json from '@/assets/images/lottie/9.json'
import lottie10Json from '@/assets/images/lottie/10.json'
import 'echarts-gl'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  components: { Lottie, vueSeamlessScroll },
  data() {
    return {
      classOption: {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      },
      lottieOne: {
        animationData: lottieOneJson,
        loop: true,
        autoplay: true
      },
      lottieTwo: {
        animationData: lottieTwoJson,
        loop: true,
        autoplay: true
      },
      lottieThree: {
        animationData: lottieThreeJson,
        loop: true,
        autoplay: true
      },
      lottieFour: {
        animationData: lottieFourJson,
        loop: true,
        autoplay: true
      },
      lottieFive: {
        animationData: lottieFiveJson,
        loop: true,
        autoplay: true
      },
      lottieSix: {
        animationData: lottieSixJson,
        loop: true,
        autoplay: true
      },
      lottie7: {
        animationData: lottie7Json,
        loop: true,
        autoplay: true
      },
      lottie8: {
        animationData: lottie8Json,
        loop: true,
        autoplay: true
      },
      lottie9: {
        animationData: lottie9Json,
        loop: true,
        autoplay: true
      },
      lottie10: {
        animationData: lottie10Json,
        loop: true,
        autoplay: true
      },
      data: {
        basicInfo: {
          allPersonCount: 0,
          governmentServiceCount: 0,
          inPensOrgCount: 0,
          oldPersonCount: 0,
          serviceMerchantCount: 0,
          smartCareCount: 0,
          workerCount: 0
        },
        communityService: {
          governmentServiceList: [],
          serviceMerchantList: []
        },
        district: {
          communityCanteenCount: 0,
          communityServiceStationCount: 0,
          comprehensiveServiceCenterCount: 0,
          medicalInstitutionCount: 0,
          ruralHappinessCourtCount: 0
        },
        srOrders: [],
        elderlyAgeCategory: {
          personAge0Count: 10,
          personAge100Count: 20,
          personAge60Count: 30,
          personAge70Count: 50,
          personAge80Count: 10,
          personAge90Count: 5,
          personTypeLayout: []
        },
        nursingHomeData: {
          admissionCount: 0,
          bedCount: 0,
          institutionCount: 0,
          nursingStaffCount: 0,
          vacantBedCount: 0
        },
        otherData: {
          callCenterCount: 0,
          communityActivityCount: 0,
          serviceDataCount: 0
        },
        serviceOrders: []
      },
      mapDataTitle: '',
      regionId: '566578',
      mapRegion: [
        { regionId: '566578', regionName: '莲湖区' },
        { regionId: '566805', regionName: '青年路街道' },
        { regionId: '566806', regionName: '北院门街道' },
        { regionId: '566807', regionName: '北关街道' },
        { regionId: '566808', regionName: '红庙坡街道' },
        { regionId: '566809', regionName: '环城西路街道' },
        { regionId: '566810', regionName: '西关街道' },
        { regionId: '566811', regionName: '土门街道' },
        { regionId: '566812', regionName: '桃园路街道' },
        { regionId: '566813', regionName: '枣园街道' },
        { regionId: '566814', regionName: '莲湖区智慧家政平台数据中心' },
      ],
      mapRegionId: '566578',
      mapData: [],
      settingConfigDesc: {
        biName: '平台名称',
        populationSize: '人口数量',
        elderlyData: '老人数据',
        baseOldPersonCount: '基础数据-老人数据',
        baseEmployees: '基础数据-从业人员',
        baseServiceMerchants: '基础数据-服务商家',
        baseNursingHome: '基础数据-养老院',
        baseCommunityServiceStation: '基础数据-社区服务站',
        baseCommunityRestaurant: '基础数据-社区餐厅',
        otherServiceData: '其他数据-服务数据',
        otherIntelligentCare: '其他数据-智能看护',
        otherCommunityActivities: '其他数据-社区活动',
        domesticService: '家政服务',
        medicalCare: '医疗护理',
        nursingHome: '医疗护理',
        communityServiceStation: '社区服务站',
        travelAccommodation: '旅游旅居',
        otherMerchants: '其他商家',
        assessmentOfElderlyAbilities: '老人能力评估',
        elderlyOrientedReform: '适老化改造',
        governmentAidServices: '政府援助服务',
        inspectionVisitationServices: '空巢独居巡视探访服务',
        mealAssistanceService: '助餐服务',
        cleaningAssistanceService: '助洁服务',
        medicalAssistanceServices: '助医服务',
        assistiveServices: '助行服务',
        urgentAssistanceService: '助急服务',
        totalNumberInstitutions: '机构总数',
        numberBeds: '床位数',
        numberNursingBeds: '护理型床位数',
        numberVacantBeds: '空闲床位数',
        numberElderlyResidents: '入住老年人数'
      },
      allCount: 0,
      serviceType: 1,
      settingConfig: {
        // 平台名称
        biName: '',
        // 老人数据
        baseOldPersonCount: '',
        // 从业人员
        baseEmployees: '',
        // 服务商家
        baseServiceMerchants: '',
        // 养老院
        baseNursingHome: '',
        // 社区服务站
        baseCommunityServiceStation: '',
        // 社区餐厅
        baseCommunityRestaurant: '',
        // 服务数据
        otherServiceData: '',
        // 智能看护
        otherIntelligentCare: '',
        // 社区活动
        otherCommunityActivities: '',
        // 人口数量
        populationSize: '',
        // 老人数据
        elderlyData: '',
        // 家政服务
        domesticService: '',
        // 医疗护理
        medicalCare: '',
        // 养老院
        nursingHome: '',
        // 社区服务站
        communityServiceStation: '',
        // 旅游旅居
        travelAccommodation: '',
        // 其他商家
        otherMerchants: '',
        // 老人能力评估
        assessmentOfElderlyAbilities: '',
        // 适老化改造
        elderlyOrientedReform: '',
        // 政府援助服务
        governmentAidServices: '',
        // 空巢独居巡视 探访服务
        inspectionVisitationServices: '',
        // 机构总数
        totalNumberInstitutions: '',
        // 床位数
        numberBeds: '',
        // 护理型床位数
        numberNursingBeds: '',
        // 空闲床位数
        numberVacantBeds: '',
        // 入住老年人数
        numberElderlyResidents: '',
        // 助餐服务
        mealAssistanceService: '',
        // 助洁服务
        cleaningAssistanceService: '',
        // 助医服务
        medicalAssistanceServices: '',
        // 助行服务
        assistiveServices: '',
        // 助急服务
        urgentAssistanceService: ''
      },
      settingConfigSet: {
        // 平台名称
        biName: '',
        // 老人数据
        baseOldPersonCount: '',
        // 从业人员
        baseEmployees: '',
        // 服务商家
        baseServiceMerchants: '',
        // 养老院
        baseNursingHome: '',
        // 社区服务站
        baseCommunityServiceStation: '',
        // 社区餐厅
        baseCommunityRestaurant: '',
        // 服务数据
        otherServiceData: '',
        // 智能看护
        otherIntelligentCare: '',
        // 社区活动
        otherCommunityActivities: '',
        // 人口数量
        populationSize: '',
        // 老人数据
        elderlyData: '',
        // 家政服务
        domesticService: '',
        // 医疗护理
        medicalCare: '',
        // 养老院
        nursingHome: '',
        // 社区服务站
        communityServiceStation: '',
        // 旅游旅居
        travelAccommodation: '',
        // 其他商家
        otherMerchants: '',
        // 老人能力评估
        assessmentOfElderlyAbilities: '',
        // 适老化改造
        elderlyOrientedReform: '',
        // 政府援助服务
        governmentAidServices: '',
        // 空巢独居巡视 探访服务
        inspectionVisitationServices: '',
        // 机构总数
        totalNumberInstitutions: '',
        // 床位数
        numberBeds: '',
        // 护理型床位数
        numberNursingBeds: '',
        // 空闲床位数
        numberVacantBeds: '',
        // 入住老年人数
        numberElderlyResidents: '',
        // 助餐服务
        mealAssistanceService: '',
        // 助洁服务
        cleaningAssistanceService: '',
        // 助医服务
        medicalAssistanceServices: '',
        // 助行服务
        assistiveServices: '',
        // 助急服务
        urgentAssistanceService: ''
      },
      showLayer: false,
      isScrolling: false,
      animationFrameId: '',
      height: 0,
      position: 0
    }
  },
  created() {
    this.mapDataTitle = '莲湖区'
    this.getDataInfo()
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationFrameId) // 取消动画帧请求，清理资源
    this.stopScroll()
  },
  methods: {
    ...mapActions(['bigDataInfo', 'loadConfig', 'overrideConfig']),
    ...mapMutations(['goToPageNew']),
    getPercentage(number) {
      if (number === '') {
        return 0
      }
      if (this.allCount === 0) {
        return 0
      }
      return number / this.allCount * 100
    },
    getDataInfo() {
      this.bigDataInfo({
        regionId: this.regionId
      }).then(res => {
        if (res.code === 200) {
          this.mapData = res.data.district.baseItemsList
          this.data = res.data
          this.$nextTick(() => {
            this.startScroll()
          })
          this.getChart()
        }
      })
      this.loadConfig({
        isolationSubUid: this.regionId,
        scene: 'BI_PANEL'
      }).then(res => {
        if (res.code === 200) {
          let allCount = 0
          res.data.forEach(item => {
            this.settingConfig[item.configKey] = item.configValue
            if (item.configKey === 'assessmentOfElderlyAbilities' ||
              item.configKey === 'elderlyOrientedReform' ||
              item.configKey === 'governmentAidServices' ||
              item.configKey === 'inspectionVisitationServices') {
              allCount += parseInt(item.configValue)
            }
          })
          this.allCount = allCount
          this.$nextTick(() => {
            this.chartThree()
          })
        }
      })
    },
    startScroll() {
      if (this.isScrolling) return // 如果已经在滚动，则不重复启动
      this.isScrolling = true
      const scrollContent = this.$refs.scrollContent
      this.height = this.$refs.scrollContentOrder[1].offsetTop - this.$refs.scrollContentOrder[0].offsetTop
      const scrollHeight = scrollContent.offsetHeight // 获取内容高度
      let position = 0 // 初始位置为0

      const frame = (timestamp) => {
        position -= 20 // 每次向上移动1px
        if (position < -scrollHeight) { // 如果滚动超出内容高度，则重置位置到0（无缝滚动）
          position = 0
        }
        this.position = position
        scrollContent.style.top = `${position}px` // 设置新的位置
        setTimeout(() => {
          this.animationFrameId = requestAnimationFrame(frame)
        }, 2000)
      }
      this.animationFrameId = requestAnimationFrame(frame)
    },
    stopScroll() {
      this.isScrolling = false
    },

    getRegionSetting(regionId) {
      this.loadConfig({
        isolationSubUid: regionId,
        scene: 'BI_PANEL'
      }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.settingConfigSet[item.configKey] = item.configValue
          })
          this.$nextTick(() => {
            this.chartThree()
          })
        }
      })
    },

    changeMapRegion() {
      this.getRegionSetting(this.mapRegionId)
    },

    getChart() {
      this.$nextTick(() => {
        this.chartOne()
        this.chartTwo()
        this.chartFour()
      })
    },
    gourl(url) {
      this.goToPageNew({ name: url })
    },
    submit() {
      const configList = []
      for (const settingConfigKey in this.settingConfigSet) {
        configList.push({
          configDesc: this.settingConfigDesc[settingConfigKey] ?? '',
          configKey: settingConfigKey,
          configValue: this.settingConfigSet[settingConfigKey]
        })
      }
      this.overrideConfig({
        isolationSubUid: this.mapRegionId,
        configList: configList,
        scene: 'BI_PANEL'
      }).then(res => {
        if (res.code === 200) {
          this.showLayer = false
          this.getDataInfo()
        }
      })
    },
    /**
     * 老年人年龄及类别
     */
    chartOne() {
      const myChart = this.$echarts.init(document.getElementById('chartOne'))
      const xData = [this.data.elderlyAgeCategory.personAge0Count, this.data.elderlyAgeCategory.personAge60Count, this.data.elderlyAgeCategory.personAge70Count, this.data.elderlyAgeCategory.personAge80Count, this.data.elderlyAgeCategory.personAge90Count, this.data.elderlyAgeCategory.personAge100Count]
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          show: false
        },
        grid: {
          left: 15,
          right: 0,
          top: 40,
          bottom: 12,
          containLabel: true
        },
        legend: {
          show: false
        },
        xAxis: [
          {
            type: 'category',
            data: [0, 60, 70, 80, 90, 100],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#65C6E7',
                fontSize: 12
              },
              formatter: function (value) {
                if (value.length === 4 || value.length === 5) {
                  const start = value.substring(0, 2)
                  const end = value.substring(2, value.length)
                  return start + '\n' + end
                } else if (value.length === 6) {
                  const start = value.substring(0, 2)
                  const end = value.substring(3, 6)
                  return start + '\n' + end
                } else {
                  return value
                }
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#227081'
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            name: '单位/人',
            nameLocation: 'end',
            nameTextStyle: {
              color: '#65C6E7',
              fontSize: 13,
              padding: [0, 30, -5, 60]
            },
            type: 'value',
            min: 0,
            max: Math.max.apply(null, xData),
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#65C6E7',
                fontSize: 13
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#227081'
              }
            }
          }],
        color: ['#14C6CA', '#FFFF00', '#F29961', '#A682E6', '#E15D68', '#14CA65'],
        series: [
          {
            name: '人',
            type: 'bar',
            data: xData,
            barWidth: 10,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: '#2FEDFE',
                color: new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#00F0FF' // 100% 处的颜色
                }])
              }
            }
          }]
      })
    },

    /**
     * 老年人年龄及类别
     */
    chartTwo() {
      const myChart = this.$echarts.init(document.getElementById('chartTwo'))
      const personTypeLayout = this.data.elderlyAgeCategory.personTypeLayout == null ? [] : this.data.elderlyAgeCategory.personTypeLayout
      const xData = personTypeLayout.map((item) => item.name)
      const yData = personTypeLayout.map((item) => item.count)
      const colorList = ['#00FF60', '#FFEA00', '#FF8C26', '#E58BFF', '#FF359E', '#00AEFF']
      const encode = []
      yData.forEach((item, index) => {
        encode.push({ name: xData[index], value: item, color: colorList[index % 6] })
      })

      myChart.setOption({
        dataset: {
          source: encode,
          dimensions: ['name', 'value', 'color'], // 定义数据维度
          encode: {
            // 这里不直接映射 borderColor，因为 ECharts 没有直接的 borderColor 映射方式
            // 我们将通过 series 中的 itemStyle 来实现类似效果
          }
        },
        title: {
          text: ''
        },
        tooltip: {
          show: false
        },
        grid: {
          left: -50,
          right: 0,
          top: 40,
          bottom: 0,
          containLabel: true
        },
        legend: {
          show: false
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#65C6E7',
                fontSize: 12
              },
              formatter: function (value) {
                if (value.length === 4 || value.length === 5) {
                  const start = value.substring(0, 2)
                  const end = value.substring(2, value.length)
                  return start + '\n' + end
                } else if (value.length === 6) {
                  const start = value.substring(0, 2)
                  const end = value.substring(3, 6)
                  return start + '\n' + end
                } else {
                  return value
                }
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#227081'
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: {
          show: false
        },
        color: [new echats.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#00FF60' // 100% 处的颜色
        }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#FFEA00' // 100% 处的颜色
        }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#FF8C26' // 100% 处的颜色
        }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#E58BFF' // 100% 处的颜色
        }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#FF359E' // 100% 处的颜色
        }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#00AEFF' // 100% 处的颜色
        }])],
        series: [
          {
            name: '人',
            type: 'bar',
            data: yData,
            barWidth: 10,
            itemStyle: {
              encode: {
                x: 'name',
                y: 'value'
              },
              normal: {
                borderWidth: 2,
                borderColor: '{color}',
                color: function (params) {
                  const colorList = [new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#00FF60' // 100% 处的颜色
                  }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#FFEA00' // 100% 处的颜色
                  }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#FF8C26' // 100% 处的颜色
                  }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#E58BFF' // 100% 处的颜色
                  }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#FF359E' // 100% 处的颜色
                  }]), new echats.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(0, 255, 177, 0)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#00AEFF' // 100% 处的颜色
                  }])]
                  return colorList[params.dataIndex % 6]
                }
              }
            }
          }]
      })
    },

    fontSize(res) {
      const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (!clientWidth) return
      const fontSize = clientWidth / 1920
      return res * fontSize
    },
    /**
     * 服务商家
     */
    chartThree() {
      const myChart = this.$echarts.init(document.getElementById('chartThree'))
      const xData = [
        '家政服务   ' + this.settingConfig.domesticService ?? 0,
        '医疗护理   ' + this.settingConfig.medicalCare ?? 0,
        '养老院   ' + this.settingConfig.nursingHome ?? 0,
        '社区服务站   ' + this.settingConfig.communityServiceStation ?? 0,
        '旅游旅居   ' + this.settingConfig.travelAccommodation ?? 0,
        '其他商家   ' + this.settingConfig.otherMerchants ?? 0
      ]
      const yData = [{
        name: '家政服务   ' + this.settingConfig.domesticService ?? 0,
        value: this.settingConfig.domesticService ?? 0
      }, {
        name: '医疗护理   ' + this.settingConfig.medicalCare ?? 0,
        value: this.settingConfig.medicalCare ?? 0
      }, {
        name: '养老院   ' + this.settingConfig.nursingHome ?? 0,
        value: this.settingConfig.nursingHome ?? 0
      }, {
        name: '社区服务站   ' + this.settingConfig.communityServiceStation ?? 0,
        value: this.settingConfig.communityServiceStation ?? 0
      }, {
        name: '旅游旅居   ' + this.settingConfig.travelAccommodation ?? 0,
        value: this.settingConfig.travelAccommodation ?? 0
      }, {
        name: '其他商家   ' + this.settingConfig.otherMerchants ?? 0,
        value: this.settingConfig.otherMerchants ?? 0
      }]
      myChart.setOption({
        graphic: [],
        // 提示框
        tooltip: {
          trigger: 'item',
          show: false
        },
        // 图例属性
        legend: {
          show: true,
          left: this.fontSize(170),
          top: this.fontSize(10),
          orient: 'vertical',
          itemGap: this.fontSize(5),
          itemWidth: this.fontSize(12),
          itemHeight: this.fontSize(12),
          textStyle: {
            fontSize: this.fontSize(18),
            color: '#628EDB'
          },
          data: xData
        },
        // 圆心区域
        // graphic: {
        //   type: 'text',
        //   left: 'center',
        //   top: 'center',
        //   style: {
        //     text: ``
        //   }
        // },
        // 系列列表
        series: [
          {
            type: 'pie',
            radius: ['60%', '80%'],
            left: -(this.fontSize(205)),
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            emphasis: {
              label: {
                show: false
              }
            },
            data: yData,
            color: ['#31E7FC', '#D2B789', '#3EB1E7', '#28E3BB', '#C8649F', '#7168D5']
          }
        ]
      })
    },

    /**
     * 地图
     */
    chartFour() {
      this.$echarts.registerMap('lianhu', lianhu)
      const myChart = this.$echarts.init(document.getElementById('chartFour'))
      const option = {
        environment: '#000',
        series: [{
          type: 'map3D',
          map: 'lianhu',
          boxDepth: 60,
          regionHeight: 4,
          itemStyle: {
            normal: {
              color: 'rgba(17,217,245,0.1)',
              borderColor: '#00FFF0',
              shadowColor: '#00FFF0',
              borderWidth: 2,
              shadowOffsetX: 10,
              shadowOffsetY: 20,
              shadowBlur: 20
            },
            emphasis: {
              color: '#00CCFF'
            }
          },
          label: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 15,
              backgroundColor: 'rgba(255,255,255,0)'
            }
          },
          viewControl: {
            zoom: 1.5,
            distance: 75,
            autoRotate: true,
            beta: 20,
            maxBeta: 3600,
            minBeta: -3600
          },
          roam: true
        }]
      }
      myChart.setOption(option)
      setInterval(() => {
        option.series[0].viewControl.beta = 20
        myChart.setOption(option)
      }, 36000)
      const that = this
      myChart.on('click', function (params) {
        console.log(params)
        let regionId = ''
        that.mapRegion.forEach((item) => {
          if (item.regionName === params.name) {
            regionId = item.regionId
          }
        })
        that.mapDataTitle = params.name
        that.regionId = regionId
        that.getDataInfo()
      })
    }
  }
}
</script>

<style scoped>

.wrapper {
  padding: 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: url('../../../assets/images/bigData/bg.png') no-repeat;
  background-size: 100% 100%;
}

.wrapper-content {
  padding: 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: url('../../../assets/images/bigData/bg_border.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 4.22rem;
  font-weight: bolder;
  /* 设置字体透明 */
  color: transparent;
  /* 设置线性渐变，从红色渐变到蓝色 */
  background-image: linear-gradient(180deg, #00DDFA 29.8583984375%, #00759C 100%);
  /* 使用 -webkit-background-clip 属性将背景剪裁至文本形状 */
  -webkit-background-clip: text;
  /* 非Webkit内核浏览器需要使用标准前缀 */
  background-clip: text;
  /* 把当前元素设置为行内块，以便能够应用背景 */
  display: inline-block;
}

.content {
  margin: 3.22rem 3.33rem 6.66rem 3.33rem;
  flex: 1;
  width: calc(100% - 6.66rem);
}

.content-left, .content-right {
  width: 44.44rem;
  height: calc(100%);
  background: rgba(4, 41, 66, 0.5);
  display: flex;
  flex-direction: column;
}

.content-center {
  width: 105.11rem;
  height: calc(100%);
  display: flex;
  flex-direction: column;
}

.content-title {
  margin: 0.63rem 0 0 0.81rem;
  padding-left: 5.81rem;
  height: 3.82rem;
  background: url('../../../assets/images/bigData/titleBg.png') no-repeat;
  background-size: 19.64rem 100%;
  display: flex;
  align-items: center;
  font-size: 1.38rem;
  color: #FFFFFF;
}

.content-one {
  margin: 0rem 0.26rem 0 1.56rem;
  display: flex;
  flex-wrap: wrap;
}

.content-one-data {
  margin: 1.18rem 0 0 1.67rem;
  background: rgba(4, 41, 66, 0.5);
  width: calc((100% - 7.34rem) / 3);
  height: 12.55rem;
  background: url('../../../assets/images/bigData/contentbg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.content-two-data {
  margin: 1.18rem 0 0 0.44rem;
  background: rgba(4, 41, 66, 0.5);
  width: calc((100% - 3rem) / 3);
  height: 16.55rem;
  background: url('../../../assets/images/bigData/contentBg2.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.content-text-1 {
  margin-top: 0.67rem;
  font-size: 1.38rem;
  color: #FFFFFF;
}

.content-text-2 {
  font-size: 0.92rem;
  color: #77CCFF;
}

.image-678 {
  width: 4.69rem;
  height: 4.69rem;
}

.image-58 {
  width: 5.45rem;
  height: 8rem;
}

.chart-one-content {
  margin: 0;
  display: flex;
  align-items: center;
}

.chart-one {
  width: 20.55rem;
  height: 28rem;
}

.chart-two {
  width: 20.55rem;
  height: 28rem;
}

.line {
  width: 0.36rem;
  height: 1.36rem;
  background: #00CCFF;
  margin: 0 0.82rem 0 1.82rem;
}

.content-line {
  margin-top: 2.64rem;
  display: flex;
  align-items: center;
}

.line-tile {
  font-size: 1.45rem;
  color: #00CCFF;
}

.content-three {
  margin: 1.27rem 0.91rem 0.91rem;
  width: 42.55rem;
  height: 18.36rem;
  background: url('../../../assets/images/bigData/contentbg.png') no-repeat;
  background-size: 100% 100%;
}

.content-four {
  margin: 1.5rem 1.73rem 0 1.73rem;
  height: 22.73rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.content-four::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari */
}

.content-four-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content-four-progress-all {
  position: relative;
  width: 31.55rem;
  height: 2.27rem;
  border: 2px solid #2AFFFF;
  margin: 1.5rem 0 1.5rem 0;
}

.content-four-percentage {
  position: absolute;
  left: 0;
  height: 2.27rem;
  background: linear-gradient(90deg, rgba(56, 246, 243, 0) 0%, rgba(56, 246, 243, 0.99) 99%);
  z-index: 2;
}

.content-four-percentage-right {
  position: absolute;
  right: 0;
  height: 2.27rem;
  max-width: 100%;
  z-index: 2;
  background-color: #043E50;
}

.content-four-number {
  position: absolute;
  right: 1rem;
  line-height: 2.27rem;
  font-weight: 400;
  font-size: 0.91rem;
  color: #37F3F0;
  z-index: 10;
}

.content-four-title {
  font-size: 1.09rem;
  color: #77CCFF;
  margin-left: 2rem;
  text-align: center;
  flex: 1;
}

.content-five {
  margin: 3.36rem 0.91rem 0 1.82rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-five-data {
  width: calc((100% - 2.73rem) / 3);
  height: 5.73rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content-five-title {
  font-size: 1.09rem;
}

.content-five-text-1 {
  font-size: 2.18rem;
}

.content-five-text-2 {
  font-size: 0.73rem;
}

.content-five-data-1 {
  background: url('../../../assets/images/bigData/contentBg41.png') no-repeat;
  background-size: 100% 100%;
}

.content-five-data-1 > .content-five-title {
  color: #02C957;
}

.content-five-data-1 .content-five-text-1 {
  text-shadow: 0 0 1rem rgba(38, 23, 6, 0.1);
  /* 设置字体透明 */
  color: transparent;
  /* 设置线性渐变，从红色渐变到蓝色 */
  background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(2, 200, 86, 0.78) 100%);
  /* 使用 -webkit-background-clip 属性将背景剪裁至文本形状 */
  -webkit-background-clip: text;
  /* 非Webkit内核浏览器需要使用标准前缀 */
  background-clip: text;
  /* 把当前元素设置为行内块，以便能够应用背景 */
  display: inline-block;
}

.content-five-data-1 .content-five-text-2 {
  color: #02C957;
}

.content-five-data-2 {
  background: url('../../../assets/images/bigData/contentBg42.png') no-repeat;
  background-size: 100% 100%;
}

.content-five-data-2 > .content-five-title {
  color: #C2B90E;
}

.content-five-data-2 .content-five-text-1 {
  text-shadow: 0 0 1 rgba(38, 23, 6, 0.1);
  /* 设置字体透明 */
  color: transparent;
  /* 设置线性渐变，从红色渐变到蓝色 */
  background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(194, 185, 14, 0.78) 100%);
  /* 使用 -webkit-background-clip 属性将背景剪裁至文本形状 */
  -webkit-background-clip: text;
  /* 非Webkit内核浏览器需要使用标准前缀 */
  background-clip: text;
  /* 把当前元素设置为行内块，以便能够应用背景 */
  display: inline-block;
}

.content-five-data-2 .content-five-text-2 {
  color: #C2B90E;
}

.content-five-data-3 {
  background: url('../../../assets/images/bigData/contentBg43.png') no-repeat;
  background-size: 100% 100%;
}

.content-five-data-3 > .content-five-title {
  color: #BF712A;
}

.content-five-data-3 .content-five-text-1 {
  text-shadow: 0 0 1rem rgba(38, 23, 6, 0.1);
  /* 设置字体透明 */
  color: transparent;
  /* 设置线性渐变，从红色渐变到蓝色 */
  background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(191, 113, 42, 0.78) 100%);
  /* 使用 -webkit-background-clip 属性将背景剪裁至文本形状 */
  -webkit-background-clip: text;
  /* 非Webkit内核浏览器需要使用标准前缀 */
  background-clip: text;
  /* 把当前元素设置为行内块，以便能够应用背景 */
  display: inline-block;
}

.content-five-data-3 .content-five-text-2 {
  color: #BF712A;
}

.content-five-data-4 {
  background: url('../../../assets/images/bigData/contentBg44.png') no-repeat;
  background-size: 100% 100%;
}

.content-five-data-4 > .content-five-title {
  color: #AC70CB;
}

.content-five-data-4 .content-five-text-1 {
  text-shadow: 0 0 1rem rgba(38, 23, 6, 0.1);
  /* 设置字体透明 */
  color: transparent;
  /* 设置线性渐变，从红色渐变到蓝色 */
  background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(172, 112, 203, 0.78) 100%);
  /* 使用 -webkit-background-clip 属性将背景剪裁至文本形状 */
  -webkit-background-clip: text;
  /* 非Webkit内核浏览器需要使用标准前缀 */
  background-clip: text;
  /* 把当前元素设置为行内块，以便能够应用背景 */
  display: inline-block;
}

.content-five-data-4 .content-five-text-2 {
  color: #AC70CB;
}

.content-five-data-5 {
  background: url('../../../assets/images/bigData/contentBg45.png') no-repeat;
  background-size: 100% 100%;
}

.content-five-data-5 > .content-five-title {
  color: #C23284;
}

.content-five-data-5 .content-five-text-1 {
  text-shadow: 0 0 1rem rgba(38, 23, 6, 0.1);
  /* 设置字体透明 */
  color: transparent;
  /* 设置线性渐变，从红色渐变到蓝色 */
  background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(195, 49, 132, 0.78) 100%);
  /* 使用 -webkit-background-clip 属性将背景剪裁至文本形状 */
  -webkit-background-clip: text;
  /* 非Webkit内核浏览器需要使用标准前缀 */
  background-clip: text;
  /* 把当前元素设置为行内块，以便能够应用背景 */
  display: inline-block;
}

.content-five-data-5 .content-five-text-2 {
  color: #C23284;
}

.content-six {
  width: 105rem;
  height: 27.82rem;
  background: rgba(4, 41, 66, 0.5);
}

table {
  width: calc(100% - 4.09rem);
  font-size: 1.1rem;
  margin: 1.64rem 1.82rem 0 2.27rem;
}

table thead tr {
  color: #FFFFFF;
  background: #032C46;
}

table td {
  height: 2.53rem;
  text-align: center;
}

table tr {
  display: table;
  table-layout: fixed;
  width: 100%;
}

table tbody tr:nth-child(2n+1) {
  background: #033F5D;
}

table tbody tr:nth-child(2n) {
  background: #023551;
}

table tbody {
  height: 15.18rem;
  overflow-y: auto;
  display: block;
  font-size: 1.01rem;
  color: #1CFBFF;
}

table tbody::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari */
}

.content-seven {
  width: 105rem;
  height: calc(100% - 27.82rem);
  position: relative;
}

.chart-four {
  margin: 0;
  width: 105rem;
  height: 58.82rem;
}

.content-seven-title {
  position: absolute;
  left: 0;
  width: 17.73rem;
  height: 2.64rem;
  background: url('../../../assets/images/bigData/titleBg1.png') no-repeat;
  background-size: 100% 100%;
  font-size: 1.09rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.content-seven-content {
  position: absolute;
  z-index: 999;
  left: 2.09rem;
  bottom: 2.27rem;
  width: 17.45rem;
  height: 12.73rem;
  background: url('../../../assets/images/bigData/contentBg5.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  font-size: 1.45rem;
  color: #00FFFC;
}

.content-seven-content-border {
  width: 13.82rem;
  height: 7.09rem;
  margin-left: 1.82rem;
  margin-top: 0.73rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 19, 32, 0.5);
  border: 1px solid #00FFFC;
}

.content-seven-content-border > img {
  width: 2.55rem;
  height: 2.55rem;
}

.content-eight-content {
  position: absolute;
  z-index: 999;
  right: 1.09rem;
  bottom: 2.27rem;
  width: 21rem;
  height: 13rem;
  overflow-y: auto;
  display: block;
}

.scroll-content {
  position: absolute;
  width: 100%;
}

.s-order {
  max-width: 18.45rem;
  min-width: 14.81rem;
  height: 3rem;
  line-height: 3rem;
  padding: 0 0 0 1.64rem;
  margin-bottom: 1.09rem;
  background: rgba(0, 210, 255, 0.2);
  border-radius: 1.45rem;
  border: 1px solid #00FCFF;
  color: #73FDFF;
  font-size: 1.09rem;
  transition: all 2s linear;
}

.scroll-content {
  transition: all 2s linear;
}

.content-eight-content::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari */
}

.content-seven-line {
  width: 100%;
  height: 0.09rem;
  background: #00FFFC;
}

.three-image {
  width: 9rem;
  height: 9rem;
  position: absolute;
  top: 15rem;
  left: 6.4rem;
}

.setting {
  position: fixed;
  right: 2rem;
  bottom: 2.36rem;
  z-index: 999;
  width: 2.18rem;
  height: 2.18rem;
}

.setting-image {
  width: 2.18rem;
  height: 2.18rem;
  display: none;
}

.setting:hover .setting-image {
  display: block !important;
}

.layer-back {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}

.layer-content {
  padding: 2.91rem 4.36rem;
  background: rgba(2, 38, 61, 0.8);
  border: 0.09rem solid #00D8FF;
  font-size: 1.45rem;
  position: relative;

}

.layer-content-content {
  max-height: calc(70vh);
  overflow-y: auto;
}

.layer-content-content::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari */
}

.layer-close {
  position: absolute;
  right: 4.36rem;
  top: 3.18rem;
  color: #00D8FF;
  font-size: 1.82rem;
}

.layer-close:hover {
  color: #7BEBFF !important;
}

.layer-close:active {
  color: #00B1D1 !important;
}

.layer-content-title {
  color: #00D8FF;
  font-size: 1.82rem;
}

.layer-input {
  width: 10.91rem;
  height: 3.64rem;
  line-height: 1.82rem;
  text-align: center;
  background: #00D8FF;
  color: #02263D;
  display: flex;
  align-items: center;
  justify-content: center;
}

.margin-top-25 {
  margin-top: 2.55rem;
}

.margin-top-18 {
  margin-top: 1.82rem;
}

.margin-left-218 {
  margin-left: 2.18rem;
}

.layer-input-content {
  width: 49.82rem;
  height: 3.46rem;
  background: #02263D;
  border: 0.09rem solid #00D8FF;
  padding: 0 2.18rem;
  color: #00D8FF;
}

.layer-select-content {
  width: 54.36rem;
  height: 3.54rem;
  background: #02263D;
  border: 0.09rem solid #00D8FF;
  padding: 0 2.18rem;
  color: #00D8FF;
}

.layer-input-content1 {
  width: 16.19rem;
  height: 3.46rem;
  background: #02263D;
  border: 0.09rem solid #00D8FF;
  padding: 0 2.18rem;
  color: #00D8FF;
}

.color-00d {
  color: #00D8FF;
}

.layer-input-content1 > input {
  height: 3.46rem;
  border: none;
  width: 100%;
  background: #02263D;
  margin-right: 1rem;
  color: #00D8FF;
}

input:focus {
  outline: none;
}

select:focus {
  outline: none;
}

.layer-button-1, .layer-button-2 {
  width: 10.91rem;
  height: 3.64rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.09rem solid #00D8FF;
}

.layer-button-1:hover, .layer-button-2:hover {
  color: #012A41 !important;
  border: 0.09rem solid #7BEBFF !important;
  background: #7BEBFF !important;
}

.layer-button-1:active, .layer-button-2:active {
  color: #012A41 !important;
  border: 0.09rem solid #00B1D1 !important;
  background: #00B1D1 !important;
}

.layer-button-1 {
  color: #00D8FF;
}

.layer-button-2 {
  background: #00D8FF;
  color: #02263D;
  margin-left: 2.18rem;
}

.content-seven-color-0 {
  color: #00FC60;
}

.content-seven-color-1 {
  color: #FEE900;
}

.content-seven-color-2 {
  color: #E38AFD;
}

.content-seven-color-3 {
  color: #F1399B;
}

.content-seven-color-4 {
  color: #F48B29;
}

.text-cut-one {
  line-height: 2.53rem;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
